module.exports = __webpack_public_path__ + "static/montserrat-medium-webfont-da183e9dd827bb3c9d09b9b9a92860ec.woff2";